import store from "../../store"
module.exports = {

  //判断是否为空
  isEmpty: function (obj) {
    function isEmptyObject(e) {
      var t;
      for (t in e)
        return !1;
      return !0
    }

    if (obj == '' || obj == null) {
      return true
    }
    if (!isNaN(obj)) {
      return false
    }
    if (obj == undefined || isEmptyObject(obj)) {
      return true
    }
    return obj.length == 0;
  },
  //比较两个对象的属性值是否一样
  isObjectValueEqual: function (a, b, props) {
    function isArray(o) {
      return Object.prototype.toString.call(o) == '[object Array]';
    }

    if (!isArray(props)) {
      return false
    }
    for (var i = 0; i < props.length; i++) {
      if (a[props[i]] != b[props[i]]) {
        return false
      }
    }
    return true;
  },
  //添加遮罩
  showLoading: function () {
    store.commit("shade",{
      shadeNum:1
    });
  },
  //消除遮罩
  stopLoading: function (timeout) {
    if(timeout === undefined){
      timeout = 0.5
    }
    setTimeout(()=>{
      store.commit('shade',{
        shadeNum:-1
      })
    },timeout * 1000)
  },
  getFileMaxSize: function () {
    return 5 * 1024 * 1024;
  },
  getFileMaxSizeName: function () {
    return '5M';
  },
  showLog: function (msg) {
    var isShowLog = true;
    if (isShowLog) {
    }
  },
  error: function (msg, _this) {
    _this.$message.error(msg)
  },
  success: function (msg, _this) {
    _this.$message.success(msg)
  },
  getStorage: function (itemName) {
    localStorage.getItem(itemName);
  },
  setStorage: function (itemName, value) {
    localStorage.setItem(itemName, value);
  },
  each: function (object, callback) {
    var type = (function () {
      switch (object.constructor) {
        case Object:
          return 'Object';
          break;
        case Array:
          return 'Array';
          break;
        case NodeList:
          return 'NodeList';
          break;
        default:
          return 'null';
          break;
      }
    })();
    // 为数组或类数组时, 返回: index, value
    if (type === 'Array' || type === 'NodeList') {
      // 由于存在类数组NodeList, 所以不能直接调用every方法
      [].every.call(object, function (v, i) {
        return callback.call(v, i, v) === false ? false : true;
      });
    }
    // 为对象格式时,返回:key, value
    else if (type === 'Object') {
      for (var i in object) {
        if (callback.call(object[i], i, object[i]) === false) {
          break;
        }
      }
    }
  },
  isInteger: function (obj) {
    if (obj == 0) {
      return true;
    }
    var r = /^\+?[1-9][0-9]*$/;　　//正整数
    return new RegExp(r).test(obj)
  },
  pictureHandle(newImgList, oldImgList, idName){
    for (let obj of oldImgList) {
      //图片默认都置为删除状态
      obj.operationType = 2;
    }
    var tempList = [...newImgList];
    for (var i = 0; i < tempList.length; i++) {
      var image = tempList[i];
      if (image[idName] == undefined) {
        image.operationType = 0;
        continue;
      }
      for (var j = 0; j < oldImgList.length; j++) {
        var apartmentRoomImage = oldImgList[j];
        if (apartmentRoomImage.operationType == 1) {
          continue;
        }
        if (apartmentRoomImage[idName] == image[idName]) {
          //若图片未删除,则置为修改状态
          apartmentRoomImage.operationType = 1;
          break;
        }
      }
    }
    for (let obj of oldImgList) {
      if (obj.operationType == 2) {
        tempList.push(obj);
      }
    }
    return tempList
  },
  /**
   * input 输入数字位数保留
   * @params precision小数位数默认不限制，为0时整数，1保留一位，2保留两位，依次类推...
   * @params inputNegative 输入负数，默认false
   * @return Number
   **/
    inputNumber(val, precision = null, inputNegative = false) {
    let result;
    if (inputNegative) {
      if (precision === 0) {
        result = val.replace(/[^\-?\d]/g, "").replace(/-{2,}/g, "-"); //整数
      } else {
        result = val.replace(/[^\-?\d.]/g, "").replace(/-{2,}/g, "-"); //清除“数字”和“.”以外的字符
      }
    } else {
      if (precision === 0) {
        result = val.replace(/[^\d]/g, ""); //整数
      } else {
        result = val.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      }
    }
    result = result.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
    result = result.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    if (precision !== null && precision !== 0) {
      let reg = new RegExp("^(-)*(\\d+)\\.(\\d{" + precision + "}).*$", "g");
      result = result.replace(reg, '$1$2.$3');
    }
    if (result.indexOf(".") < 0 && result !== "" && result !== "-" && result !== "-0") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的数字
      result = parseFloat(result);
    }
    return result;
  },
  getUniqueNames  (arr1, arr2, field)  {
    const valuesInArray1 = new Set(arr1.map(item => item[field]));
    const valuesInArray2 = new Set(arr2.map(item => item[field]));
    const differentInArray1 = arr1.filter(item => !valuesInArray2.has(item[field]));
    const differentInArray2 = arr2.filter(item => !valuesInArray1.has(item[field]));
    return {
      differentInArray1,
      differentInArray2
    };
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/utils.js